export default __webpack_public_path__ + "static/share-brandpage-url@2x-dd842ddebd489466e4fc1e3b5886a625.png";